/* Zivaria language button + automatic language on the first visit */
(() => {
  if (window.__zvLang) return;
  window.__zvLang = true;

  const KEY = 'zv_lang';
  const store = {
    get() { try { return localStorage.getItem(KEY); } catch (e) { return null; } },
    set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} },
  };

  const readRoot = () => {
    const root = document.querySelector('[data-zv-lang]');
    if (!root) return null;
    let map = {};
    try { map = JSON.parse(root.dataset.map || '{}'); } catch (e) {}
    return { root, map, current: root.dataset.current, primary: root.dataset.default, country: (root.dataset.country || '').toUpperCase() };
  };

  // Which language fits this visitor: country first, then the browser language
  const pickLanguage = (map, country) => {
    const has = (code) => Object.keys(map).find((k) => k.toLowerCase().split('-')[0] === code);
    const byCountry = { PT: 'pt', AO: 'pt', MZ: 'pt', BR: 'pt', ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es' };
    if (byCountry[country] && has(byCountry[country])) return has(byCountry[country]);
    const langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']).map((l) => String(l).toLowerCase().split('-')[0]);
    for (const l of langs) {
      if (has(l)) return has(l);
    }
    return null;
  };

  const auto = () => {
    const r = readRoot();
    if (!r || store.get()) return;
    if (/[?&]zvlang=off/.test(location.search)) return;
    if (navigator.webdriver && !/[?&]zvlang=on/.test(location.search)) return;
    store.set('auto');
    // Only decide for visitors who arrive on the default language
    if (!r.primary || r.current !== r.primary) return;
    const target = pickLanguage(r.map, r.country);
    if (!target || target === r.current || !r.map[target]) return;
    const prefix = r.map[target].replace(/\/$/, '');
    location.replace(prefix + (location.pathname === '/' ? '/' : location.pathname) + location.search + location.hash);
  };
  window.zvLangAuto = auto;

  // Languages inside the phone menu, built from the top bar options
  const addMenuLangs = () => {
    const r = readRoot();
    const foot = document.querySelector('[data-zv-mm] .zv-mm__foot');
    if (!r || !foot || foot.querySelector('.zv-mm__langs')) return;
    const wrap = document.createElement('div');
    wrap.className = 'zv-mm__langs';
    r.root.querySelectorAll('.zv-annc__langopt').forEach((o) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'zv-mm__lang';
      b.dataset.zvMmLang = o.dataset.language;
      b.textContent = o.textContent;
      if (o.dataset.language === r.current) b.setAttribute('aria-pressed', 'true');
      wrap.appendChild(b);
    });
    foot.prepend(wrap);
  };

  const close = (r) => {
    const btn = r.root.querySelector('[data-zv-lang-btn]');
    const menu = r.root.querySelector('.zv-annc__langmenu');
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
  };

  const choose = (r, code) => {
    store.set('manual');
    const form = r.root.querySelector('[data-zv-lang-form]');
    if (!form) return;
    form.querySelector('[data-zv-lang-input]').value = code;
    form.submit();
  };

  document.addEventListener('click', (e) => {
    const r = readRoot();
    if (!r) return;
    const btn = e.target.closest('[data-zv-lang-btn]');
    if (btn) {
      const menu = r.root.querySelector('.zv-annc__langmenu');
      const open = menu.hidden;
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) menu.querySelector('[aria-checked="true"], button')?.focus();
      return;
    }
    const opt = e.target.closest('[data-zv-lang] [data-language], [data-zv-mm-lang]');
    if (opt) {
      const code = opt.dataset.language || opt.dataset.zvMmLang;
      if (code && code !== r.current) choose(r, code);
      else close(r);
      return;
    }
    if (!e.target.closest('[data-zv-lang]')) close(r);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const r = readRoot();
    if (r) { close(r); r.root.querySelector('[data-zv-lang-btn]')?.focus(); }
  });

  const start = () => { auto(); addMenuLangs(); };
  window.zvLangMenu = addMenuLangs;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
